import { render, staticRenderFns } from "./FiHome.vue?vue&type=template&id=10855bde&scoped=true&"
import script from "./FiHome.vue?vue&type=script&lang=ts&"
export * from "./FiHome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10855bde",
  null
  
)

export default component.exports